@if (_transaction && !sendingReceipt && !actionClicked) {
  <div style="padding: 20px;">
    <div style="display: flex; justify-content: space-between;">
      <h2 class="cpo-dialog-title">Transaction Details</h2>
      <close-x (click)="close_click()"></close-x>
    </div>
    <div style="display: flex; align-items: stretch; justify-content: space-between; flex-wrap: wrap; padding: 0px 0px 0px 30px; margin-top: 20px;">
      <div style="flex: 1;">
        <div class="cpo-pod">
          <span class="title">Customer</span>
          <span class="r1">{{ _transaction.customerFirstName }} {{ _transaction.customerLastName }}</span>
        </div>
      </div>
      <div style="flex: 1;">
        <div class="cpo-pod">
          <span class="title">Transaction</span>
          <span class="r1">{{ _transaction.successful ? 'Successful' : 'Failed' }}</span>
        </div>
      </div>
    </div>
    <div style="padding: 0px 0px 0px 30px; margin-top: 10px;">
      <div style="display: flex; gap: 10px;">
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Date:</span>
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ formattedTransactionDate }}</span>
      </div>
      <div style="display: flex; gap: 10px;">
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Type:</span>
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.type }}</span>
      </div>
      <!-- <div style="display: flex; gap: 10px;">
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Method:</span>
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">Have questions?</span>
      </div> -->
      <div style="display: flex; gap: 10px;">
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Amount:</span>
        <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.totalAmount }}</span>
      </div>
      @if (_transaction.cardType != 'Other') {
        <div style="display: flex; gap: 10px; margin-top: 30px;">
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Card Type:</span>
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.cardType }}</span>
        </div>
        <div style="display: flex; gap: 10px;">
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Card Number:</span>
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.cardFirst6 }}****{{ _transaction.cardLast4 }}</span>
        </div>
        <div style="display: flex; gap: 10px;">
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Card Expiration:</span>
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.cardExpMonth }} / {{ _transaction.cardExpYear }}</span>
        </div>
      } @else {
        <div style="display: flex; gap: 10px; margin-top: 30px;">
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Payment Type:</span>
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">ACH</span>
        </div>
        <div style="display: flex; gap: 10px;">
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 600;">Account Number:</span>
          <span style="font-family: Booton; color: var(--green-800); font-size: 14px; font-weight: 400;">{{ _transaction.cardFirst6 }}****{{ _transaction.cardLast4 }}</span>
        </div>
      }
      <div *ngIf="canManageTransaction" style="display: flex; justify-content: center; gap: 10px; margin-top: 80px; padding-right: 30px;">
        <button class="btn-soft-secondary" (click)="sendTransactionToCustomer()">Send Receipt</button>
        <button class="btn-soft-secondary" [hidden]="!_transaction.allowRefund || sameDayTransaction" (click)="onActionButtonClicked('saleReturn')">Begin Sale Return</button>
        <button class="btn-soft-secondary" [hidden]="!_transaction.allowRefund || !sameDayTransaction" (click)="onActionButtonClicked('saleVoid')">Begin Sale Void</button>
        <button class="btn-soft-secondary" [hidden]="!_transaction.allowVoid" (click)="onActionButtonClicked('void')">Void</button>
        <button class="btn-soft-secondary" [hidden]="!_transaction.allowCapture" (click)="onActionButtonClicked('capture')">Capture</button>
        <button class="btn-soft-secondary" [hidden]="!canCancelRecurringPayment" [disabled]="disableCancelRecurringPayment" (click)="onActionButtonClicked('cancelRecurringPayment')">Cancel Recurring Payment</button>
      </div>
    </div>
  </div>
} @else if (sendingReceipt && !loading && !actionClicked) {
  <div style="padding:20px;">
    <div style="display: flex; justify-content: flex-end;">
      <span style="font-family: Booton; color: var(--green-800); font-size: 20px; font-weight: 300; cursor: pointer;" (click)="close_click()">X</span>
    </div>
    <div style="padding: 20px; align-items: center; justify-content: center; display: flex; gap: 10px;">
      <!-- Green Checkmark -->
      <svg style="width: 50px; height: 50px; fill: var(--green-400);" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320 576C178.6 576 64 461.4 64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576zM438 209.7C427.3 201.9 412.3 204.3 404.5 215L285.1 379.2L233 327.1C223.6 317.7 208.4 317.7 199.1 327.1C189.8 336.5 189.7 351.7 199.1 361L271.1 433C276.1 438 282.9 440.5 289.9 440C296.9 439.5 303.3 435.9 307.4 430.2L443.3 243.2C451.1 232.5 448.7 217.5 438 209.7z"/></svg>
      @if (transactionError) {
        <span style="font-family: Booton; color: var(--green-800); font-size: 16px; font-weight: 300;">A receipt could not be sent. {{ transactionError }}</span>
      } @else {
        <span style="font-family: Booton; color: var(--green-800); font-size: 16px; font-weight: 300;">A receipt has been sent.</span>
      }
    </div>
  </div>
} @else if (actionClicked && !loading) {
  <div style="padding:20px;">
    <div style="display: flex; justify-content: space-between;">
      <h2 class="cpo-dialog-title">{{ actionTitle }}</h2>
      <span style="font-family: Booton; color: var(--green-800); font-size: 20px; font-weight: 300; cursor: pointer;" (click)="close_click()">X</span>
    </div>
    <div style="padding: 20px; align-items: center; justify-content: center; display: flex; flex-direction: column; gap: 10px;">
      @if (hasBeenPartiallyRefunded) {
        <span style="font-family: Booton; color: var(--green-800); font-size: 16px; font-weight: 300;">This transaction has already been partially refunded for: <span style="font-weight: 600;">{{ partiallyRefundedAmount }}</span>.</span>
      }
      <span style="font-family: Booton; color: var(--green-800); font-size: 16px; font-weight: 300;">To {{ actionMessage }} this transaction, you'll be redirected to <span style="font-weight: 600;">Virtual Terminal.</span> Would you like to continue?</span>
      <div style="display: flex; justify-content: center; gap: 10px; margin-top: 40px; padding-right: 30px;">
        <button class="btn-secondary" style="width: 200px;" (click)="close_click()">Cancel</button>
        <button class="btn-primary" style="width: 200px;" (click)="onContinueClicked()">Continue</button>
      </div>
    </div>
  </div>
} @else {
  <div style="padding: 20px; align-items: center; justify-content: center; display: flex;">
    <mat-progress-spinner mode="indeterminate" style="width: 100px; height: 100px;"></mat-progress-spinner>    
  </div>
}
